module.exports = __webpack_public_path__ + "static/media/sandwich.7f1884e0.png";